import $ from 'jquery';
import Swiper from 'swiper/bundle';

// init Swiper:
const client_swiper = new Swiper('.client-swiper', {

    // Optional parameters
    observer: true,
    observeParents: true,
    loop: true,
    speed: 800,
    autoplay: true,

    breakpoints: {

        280: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        420: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 16,
        },
    }

});

//export default client_swiper;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/client-slider.js